import { useSelector } from "react-redux";

import Stack from "@mui/material/Stack";
import NavLink from "../../../../../components/links/NavLink";
import LanguageSwitcher from "../../../../../components/links/LanguageSwitcher";
import pages from '../../../../../components/const/Pages'

const DesktopMenu = () => {
    const scrollThresholdPassed = useSelector((state) => state.theme.scrollThresholdPassed);
    const color = scrollThresholdPassed ? 'common.black' : 'common.white'
    return(
        <Stack direction="row" spacing={2} sx={{alignItems:'center'}}>
            {pages().map((page, i) => (
                <NavLink key={i} page={page} color={color}/>
            ))}
            <LanguageSwitcher color={color}/>
        </Stack>
    )
}

export default DesktopMenu;